import axios from 'axios';

const getFile = name => axios.get(name);
const baseUrl = process.env.BASE_URL;

const getDataSet = (lang) => {
  return new Promise((resolve, reject) => {
    getFile(`${baseUrl}data/computedDataset${lang === 'ita' ? '' : 'Eng'}.json`).then(response => {
      resolve(response.data);
    }, error => {
      reject(error);
    })
  })
};
const getAuthorsDataSet = (lang) => {
  return new Promise((resolve, reject) => {
    getFile(`${baseUrl}data/authors${lang === 'ita' ? '' : 'Eng'}.json`).then(response => {
      resolve(response.data);
    }, error => {
      reject(error);
    })
  })
};

const getScenesDataSet = (lang) => {
  return new Promise((resolve, reject) => {
    getFile(`${baseUrl}data/scenes-list${lang === 'ita' ? '' : '-eng'}.json`).then(response => {
      resolve(response.data);
    }, error => {
      reject(error);
    })
  })
};


export default { getDataSet, getAuthorsDataSet,getScenesDataSet };
